import { ReactElement } from 'react'
import { Icon } from 'bd-web-components'
import { PRIMARY_RED_01 } from 'bd-web-components/src/utils/dash-colors'
import chevronRight from '../../assets/event-options/chevron-right.svg'
import {
  Card,
  IconBox,
  CardBody,
  CardTitleRow,
  CardTitle,
  CardBadge,
  CardDescription,
  Chevron,
} from './styles'

interface EventOptionCardProps {
  title: string
  description: string
  /** SVG asset url; takes precedence over iconName */
  iconSrc?: string
  /** bd-web-components icon name, rendered in red as fallback */
  iconName?: string
  badge?: string
  onClick?: () => void
}

export const EventOptionCard = ({
  title,
  description,
  iconSrc,
  iconName,
  badge,
  onClick,
}: EventOptionCardProps): ReactElement => (
  <Card onClick={onClick}>
    <IconBox>
      {iconSrc ? (
        <img src={iconSrc} alt="" />
      ) : iconName ? (
        <Icon
          fill={PRIMARY_RED_01}
          classes=""
          iconName={iconName}
          width={22}
          height={22}
        />
      ) : null}
    </IconBox>
    <CardBody>
      <CardTitleRow>
        <CardTitle>{title}</CardTitle>
        {badge && <CardBadge>{badge}</CardBadge>}
      </CardTitleRow>
      <CardDescription>{description}</CardDescription>
    </CardBody>
    <Chevron src={chevronRight} alt="" />
  </Card>
)

export default EventOptionCard
